import { render, staticRenderFns } from "./MemberChangeDropdown.vue?vue&type=template&id=71ff22c3&scoped=true"
import script from "./MemberChangeDropdown.vue?vue&type=script&lang=js"
export * from "./MemberChangeDropdown.vue?vue&type=script&lang=js"
import style0 from "./MemberChangeDropdown.vue?vue&type=style&index=0&id=71ff22c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff22c3",
  null
  
)

export default component.exports